module.exports = __webpack_public_path__ + "img/006_old.487583ec.png";